import Ad from 'src/components/ads/Ad';
import ImageTitle from 'src/components/articledisplays/ImageTitle';
import { ASPECT_2_1 } from 'src/components/articledisplays/ImageTitleAspect2_1';
import { ASPECT_PANORAMA } from 'src/components/articledisplays/ImageTitleAspectPanorama';
import ButtonLink from "src/components/buttonlink/ButtonLink";
import PopularMoviesRow from 'src/components/forsiden/PopularMoviesRow';
import { isAdContent } from "src/components/forsiden/utilsv2";
import styles from './TopBlockV2.module.css';
import { GroupedLayoutObject, ITopBlock, PublishableDocument } from "src/lib/types/IForsidenV2";
import IMovieList from "src/lib/types/MovieList";
import classNames from "classnames";

//#region [Other]
const TOP_SIZES_MULTIPLE = `(min-width: 1641px) 820px, ((max-width: 1640px) and (min-width: 550px)) 50vw, 100vw`;
const TOP_SIZES_SINGLE = `(min-width: 1641px) 1640px, 100vw`;
//#endregion

//#region [Props]
type TopBlockProps = {
    block: GroupedLayoutObject<ITopBlock>;

};
//#endregion

//#region [Component]
export default function TopBlockV2({ block }: TopBlockProps) {
    if ((block.articles?.length ?? 0) === 0) return null;
    const topArticles = (block.articles?.slice(0, 2) ?? []) as Exclude<PublishableDocument, IMovieList>[];
    if (topArticles.length === 0) {
        return null;
    }
    return <div className={styles.STopBlock}>

        <ImageTitle className={classNames(styles.SArticleImageTitle, { [styles.fullWidth]: topArticles.length === 1 })}
            sizes={topArticles.length === 1 ? TOP_SIZES_SINGLE : TOP_SIZES_MULTIPLE}
            document={topArticles[0]}
            forcedAspect={topArticles.length > 1 ? ASPECT_2_1 : ASPECT_PANORAMA}
            themeValue={block.themes0}
            isContentAd={isAdContent(topArticles[0])}
            useSectionTitle
        />

        <div className={styles.SNewsLinkContainer}>
            <ButtonLink className={styles.SToNewsSectionButtonLink} href='/filmnytt'>Les flere filmnyheter</ButtonLink>
        </div>

        <PopularMoviesRow />

        <Ad className={styles.STopAd} targetId='FW_topp_forside' canHide={false} height="300" mobileScreenWidth />

        {topArticles.length > 1 && <ImageTitle
            className={styles.SArticleImageTitle}
            sizes={TOP_SIZES_MULTIPLE}
            document={topArticles[1]}
            forcedAspect={ASPECT_2_1}
            themeValue={block.themes1}
            isContentAd={isAdContent(topArticles[1])}
            useSectionTitle />}


    </div>;
}
//#endregion

